import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconPreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 12.2858C5.79658 12.2858 3.29506 10.1494 1.96009 8.8299C1.39282 8.26917 1.41226 7.3757 2.00486 6.84181C3.3504 5.62954 5.82097 3.71436 8 3.71436C10.179 3.71436 12.6496 5.62955 13.9951 6.84181C14.5877 7.3757 14.6072 8.26917 14.0399 8.8299C12.7049 10.1495 10.2034 12.2858 8 12.2858Z",
  stroke: "black",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3002 7.99997C10.3002 9.31135 9.26098 10.3571 8.0002 10.3571C6.73942 10.3571 5.7002 9.31135 5.7002 7.99997C5.7002 6.68858 6.73942 5.64282 8.0002 5.64282C9.26098 5.64282 10.3002 6.68858 10.3002 7.99997Z",
  stroke: "black"
}));
export { IconPreview };